export const toCapitalize = (word) => {
  let newString = word.split(' ');
  newString = newString.map((item) => {
    return `${item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()} `;
  });

  return newString.join(' ');
};
